module.exports = __webpack_public_path__ + "static/video_img_02-d909bfe08f4c120b557a9edc44e14b46.jpg";